import "./index.css";
import "./i18n";
import reportWebVitals from "./reportWebVitals";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";

const auth0Domain =
  process.env.REACT_APP_AUTH0_DOMAIN || "dev-xxv0lr7hpm1hj6h6.eu.auth0.com";
const auth0ClientId =
  process.env.REACT_APP_AUTH0_CLIENT_ID || "IugqId5Ep1TB0F7qssqqh8ee9st62dkk";
const auth0Audience =
  process.env.REACT_APP_AUTH0_AUDIENCE || "https://api.your-app.com";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: auth0Audience,
        scope: "openid profile email",
      }}
    >
      <App />
    </Auth0Provider>
  </StrictMode>,
);

reportWebVitals();
